module.exports = __webpack_public_path__ + "static/img/jbg2.3e742ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jbg2.png
// module id = +eW4
// module chunks = 1